module.exports = __webpack_public_path__ + "img/cam-call.d694368b.png";